// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { PenIcon as PenGlyph } from "@phosphor-icons/react/dist/ssr/Pen";
import { PenNibIcon as PenNibGlyph } from "@phosphor-icons/react/dist/ssr/PenNib";
import { PencilSimpleIcon as PencilSimpleGlyph } from "@phosphor-icons/react/dist/ssr/PencilSimple";
import { PencilSimpleLineIcon as PencilSimpleLineGlyph } from "@phosphor-icons/react/dist/ssr/PencilSimpleLine";
import { PhoneIcon as PhoneGlyph } from "@phosphor-icons/react/dist/ssr/Phone";
import { PhoneXIcon as PhoneXGlyph } from "@phosphor-icons/react/dist/ssr/PhoneX";
import { PlantIcon as PlantGlyph } from "@phosphor-icons/react/dist/ssr/Plant";
import { PlayIcon as PlayGlyph } from "@phosphor-icons/react/dist/ssr/Play";
import { PlayCircleIcon as PlayCircleGlyph } from "@phosphor-icons/react/dist/ssr/PlayCircle";
import { PlugIcon as PlugGlyph } from "@phosphor-icons/react/dist/ssr/Plug";
import { PlusIcon as PlusGlyph } from "@phosphor-icons/react/dist/ssr/Plus";
import { PresentationIcon as PresentationGlyph } from "@phosphor-icons/react/dist/ssr/Presentation";
import { ProhibitIcon as ProhibitGlyph } from "@phosphor-icons/react/dist/ssr/Prohibit";
import { PushPinIcon as PushPinGlyph } from "@phosphor-icons/react/dist/ssr/PushPin";
import { PushPinSlashIcon as PushPinSlashGlyph } from "@phosphor-icons/react/dist/ssr/PushPinSlash";
import { PuzzlePieceIcon as PuzzlePieceGlyph } from "@phosphor-icons/react/dist/ssr/PuzzlePiece";
import { QuestionIcon as QuestionGlyph } from "@phosphor-icons/react/dist/ssr/Question";
import { QuotesIcon as QuotesGlyph } from "@phosphor-icons/react/dist/ssr/Quotes";
import { RectangleIcon as RectangleGlyph } from "@phosphor-icons/react/dist/ssr/Rectangle";
import { RecycleIcon as RecycleGlyph } from "@phosphor-icons/react/dist/ssr/Recycle";
import { RobotIcon as RobotGlyph } from "@phosphor-icons/react/dist/ssr/Robot";
import { ScalesIcon as ScalesGlyph } from "@phosphor-icons/react/dist/ssr/Scales";
import { ScanIcon as ScanGlyph } from "@phosphor-icons/react/dist/ssr/Scan";
import { ScissorsIcon as ScissorsGlyph } from "@phosphor-icons/react/dist/ssr/Scissors";
import { ScrollIcon as ScrollGlyph } from "@phosphor-icons/react/dist/ssr/Scroll";
import { SealCheckIcon as SealCheckGlyph } from "@phosphor-icons/react/dist/ssr/SealCheck";
import { ShareNetworkIcon as ShareNetworkGlyph } from "@phosphor-icons/react/dist/ssr/ShareNetwork";
import { ShieldIcon as ShieldGlyph } from "@phosphor-icons/react/dist/ssr/Shield";
import { ShieldCheckIcon as ShieldCheckGlyph } from "@phosphor-icons/react/dist/ssr/ShieldCheck";
import { ShieldWarningIcon as ShieldWarningGlyph } from "@phosphor-icons/react/dist/ssr/ShieldWarning";
import { ShoppingBagIcon as ShoppingBagGlyph } from "@phosphor-icons/react/dist/ssr/ShoppingBag";
import { ShoppingCartIcon as ShoppingCartGlyph } from "@phosphor-icons/react/dist/ssr/ShoppingCart";
import { SidebarSimpleIcon as SidebarSimpleGlyph } from "@phosphor-icons/react/dist/ssr/SidebarSimple";
import { SignOutIcon as SignOutGlyph } from "@phosphor-icons/react/dist/ssr/SignOut";
import { SignatureIcon as SignatureGlyph } from "@phosphor-icons/react/dist/ssr/Signature";

export const Pen = /* @__PURE__ */ createAppIcon(PenGlyph, "Pen");
export const PenNib = /* @__PURE__ */ createAppIcon(PenNibGlyph, "PenNib");
export const PencilSimple = /* @__PURE__ */ createAppIcon(
  PencilSimpleGlyph,
  "PencilSimple",
);
export const PencilSimpleLine = /* @__PURE__ */ createAppIcon(
  PencilSimpleLineGlyph,
  "PencilSimpleLine",
);
export const Phone = /* @__PURE__ */ createAppIcon(PhoneGlyph, "Phone");
export const PhoneX = /* @__PURE__ */ createAppIcon(PhoneXGlyph, "PhoneX");
export const Plant = /* @__PURE__ */ createAppIcon(PlantGlyph, "Plant");
export const Play = /* @__PURE__ */ createAppIcon(PlayGlyph, "Play");
export const PlayCircle = /* @__PURE__ */ createAppIcon(
  PlayCircleGlyph,
  "PlayCircle",
);
export const Plug = /* @__PURE__ */ createAppIcon(PlugGlyph, "Plug");
export const Plus = /* @__PURE__ */ createAppIcon(PlusGlyph, "Plus");
export const Presentation = /* @__PURE__ */ createAppIcon(
  PresentationGlyph,
  "Presentation",
);
export const Prohibit = /* @__PURE__ */ createAppIcon(
  ProhibitGlyph,
  "Prohibit",
);
export const PushPin = /* @__PURE__ */ createAppIcon(PushPinGlyph, "PushPin");
export const PushPinSlash = /* @__PURE__ */ createAppIcon(
  PushPinSlashGlyph,
  "PushPinSlash",
);
export const PuzzlePiece = /* @__PURE__ */ createAppIcon(
  PuzzlePieceGlyph,
  "PuzzlePiece",
);
export const Question = /* @__PURE__ */ createAppIcon(
  QuestionGlyph,
  "Question",
);
export const Quotes = /* @__PURE__ */ createAppIcon(QuotesGlyph, "Quotes");
export const Rectangle = /* @__PURE__ */ createAppIcon(
  RectangleGlyph,
  "Rectangle",
);
export const Recycle = /* @__PURE__ */ createAppIcon(RecycleGlyph, "Recycle");
export const Robot = /* @__PURE__ */ createAppIcon(RobotGlyph, "Robot");
export const Scales = /* @__PURE__ */ createAppIcon(ScalesGlyph, "Scales");
export const Scan = /* @__PURE__ */ createAppIcon(ScanGlyph, "Scan");
export const Scissors = /* @__PURE__ */ createAppIcon(
  ScissorsGlyph,
  "Scissors",
);
export const Scroll = /* @__PURE__ */ createAppIcon(ScrollGlyph, "Scroll");
export const SealCheck = /* @__PURE__ */ createAppIcon(
  SealCheckGlyph,
  "SealCheck",
);
export const ShareNetwork = /* @__PURE__ */ createAppIcon(
  ShareNetworkGlyph,
  "ShareNetwork",
);
export const Shield = /* @__PURE__ */ createAppIcon(ShieldGlyph, "Shield");
export const ShieldCheck = /* @__PURE__ */ createAppIcon(
  ShieldCheckGlyph,
  "ShieldCheck",
);
export const ShieldWarning = /* @__PURE__ */ createAppIcon(
  ShieldWarningGlyph,
  "ShieldWarning",
);
export const ShoppingBag = /* @__PURE__ */ createAppIcon(
  ShoppingBagGlyph,
  "ShoppingBag",
);
export const ShoppingCart = /* @__PURE__ */ createAppIcon(
  ShoppingCartGlyph,
  "ShoppingCart",
);
export const SidebarSimple = /* @__PURE__ */ createAppIcon(
  SidebarSimpleGlyph,
  "SidebarSimple",
);
export const SignOut = /* @__PURE__ */ createAppIcon(SignOutGlyph, "SignOut");
export const Signature = /* @__PURE__ */ createAppIcon(
  SignatureGlyph,
  "Signature",
);
